<div #mapContainer [class.show]="isMapLoaded" class="map-container"></div>
